export { AvatarRoot as Root } from "./root/AvatarRoot.js";
export { AvatarImage as Image } from "./image/AvatarImage.js";
export { AvatarFallback as Fallback } from "./fallback/AvatarFallback.js";